import EditNameDialog from './EditNameDialog';
import ConnectedEditNameDialog from './ConnectedEditNameDialog';

export { EditNameDialog };
export default ConnectedEditNameDialog;
